// extracted by mini-css-extract-plugin
module.exports = {"root":"ReportDetails_root__2Sok9","header":"ReportDetails_header__jX0Bu","title":"ReportDetails_title__2dMMN","left":"ReportDetails_left__235uS"};